import core from '@/core';

export default {
  install(Vue) {
    Vue.filter('years', (date) => {
      if (typeof date === 'string') {
        date = core.utils.string.toDate(date);
      }
      const age = (new Date().getTime() - new Date(date)) / (24 * 3600 * 365.25 * 1000) || 0;
      let txt;
      let count = age % 100;
      if (count >= 5 && count <= 20) {
        txt = 'лет';
      } else {
        count %= 10;
        if (count === 1) {
          txt = 'год';
        } else if (count >= 2 && count <= 4) {
          txt = 'года';
        } else {
          txt = 'лет';
        }
      }
      return `${age} ${txt}`;
    });
  },
};
